import { MutableRefObject } from 'react';
import { Space } from 'antd';
import { PrimaryButton, SecondaryButton } from 'components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface UpdateClaimButtonGroupPros {
  submitProcess: MutableRefObject<string[]>;
}
const UpdateClaimButtonGroup = (props: UpdateClaimButtonGroupPros) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Space>
      <PrimaryButton htmlType="submit" disabled={props.submitProcess.current.length > 0}>
        {t('editClaim.update')}
      </PrimaryButton>
      <SecondaryButton onClick={() => navigate(-1)}>{t('common.cancel')}</SecondaryButton>
    </Space>
  );
};

export default UpdateClaimButtonGroup;
